import { useMemo } from "react";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import { SAL2100_R01BrandDto } from "../Dto_SAL2100_R01";

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = ["#00c853", "#ff6666", "#2fc3e8", "#6d94cf", "#bf755f", "#d8df16", "#7c6ee6", "#4db6ac"];

export const BrandChart_SAL2100_R01 = ({ data }: { data: SAL2100_R01BrandDto[] }) => {
	const chartData = useMemo(() => ({
		labels: data.map((item) => item.brandNm || item.brandCd || "미지정"),
		datasets: [{
			data: data.map((item) => item.salesAmount),
			backgroundColor: data.map((_, index) => COLORS[index % COLORS.length]),
			borderColor: "#ffffff",
			borderWidth: 1,
		}],
	}), [data]);

	return (
		<div className="h-[300px] w-full border border-gray-300 p-2">
			<Doughnut
				data={chartData}
				options={{
					maintainAspectRatio: false,
					responsive: true,
					cutout: "58%",
					plugins: {
						legend: { position: "bottom" },
						tooltip: {
							callbacks: {
								label: (context) => {
									const item = data[context.dataIndex];
									return `${context.label}: ${item.shareRate.toFixed(2)}%`;
								},
							},
						},
					},
				}}
			/>
		</div>
	);
};
